import { BlogListQuery } from '../queries/messikaNewsQueries/BlogList.gql'
import { findStoreByLocaleOrPrefix } from './store'

export const BLOG_TYPE_EVENT = 'EVENT'
export const BLOG_TYPE_CELEBRITY = 'CELEBRITY'
export const BLOG_TYPE_THIS_IS_M = 'THIS_IS_M'
export const BLOG_TYPE_TV = 'TV'
export const BLOG_TYPE_PODCAST = 'PODCAST'

export const BLOG_PAGE_PARAM_URL_NAME = 'page'

export const PAGE_SIZE_FOR_RUBRIC = {
  BLOG_TYPE_EVENT: 6,
  BLOG_TYPE_CELEBRITY: 8,
  BLOG_TYPE_THIS_IS_M: 6,
  BLOG_TYPE_TV: 6,
  BLOG_TYPE_PODCAST: 3,
}

export type BlogTypeEnum =
  | typeof BLOG_TYPE_EVENT
  | typeof BLOG_TYPE_CELEBRITY
  | typeof BLOG_TYPE_THIS_IS_M
  | typeof BLOG_TYPE_TV
  | typeof BLOG_TYPE_PODCAST

export type CmsBlogItem = {
  name: string
  image: string
  id: number
  date: Date | null
  url: string
  description: string
  secondImage: string | null
}

export type CmsBlogList = {
  items: CmsBlogItem[]
  blogHomeData: {
    title: string
    image: string
    meta_title: string
    meta_keywords: string
    meta_description: string
    breadcrumbs: ({
      url?: string | null
      name?: string | null
    } | null)[]
  }
  totalItems: number
}

export const getRubricBySlug = (slug: string, locale: string): BlogTypeEnum | null => {
  // Les types de rubriques
  // EVENT: $type == 'evenements' || $type == 'events' || $type == 'eventos'
  // CELEBRITY: $type == 'celebrites' || $type == 'celebrities' || $type == 'prominente' || $type == 'celebridades'
  // TV: $type == 'messikatv'
  // THIS_IS_M: $type == 'thisism' || $type == 'todosobrem'
  
  const store = findStoreByLocaleOrPrefix(locale)
  switch (slug) {
    case store.slugs.events:
      return BLOG_TYPE_EVENT
    case store.slugs.messikatv:
      return BLOG_TYPE_TV
    case store.slugs.celebrities:
      return BLOG_TYPE_CELEBRITY
    case store.slugs.thisism:
      return BLOG_TYPE_THIS_IS_M 
    default:
      return null
  }
}

export const getSlugByStoreRubric = (rubric: BlogTypeEnum, locale: string): string => {
  const store = findStoreByLocaleOrPrefix(locale)
  switch (rubric) {
    case BLOG_TYPE_EVENT:
      return store.slugs.events
    case BLOG_TYPE_TV:
      return store.slugs.messikatv
    case BLOG_TYPE_CELEBRITY:
      return store.slugs.celebrities
    case BLOG_TYPE_THIS_IS_M:
      return store.slugs.thisism
    default:
      return ''
  }
}

export const transformBlogListQueryToBlogList = (blogListQuery: BlogListQuery): CmsBlogList => {
  const cmsBlockItems: CmsBlogItem[] =
    blogListQuery?.blogList?.items?.map((item) => ({
      id: item?.id ?? 0,
      name: item?.name ?? '',
      date: item?.date ? new Date(item.date * 1000) : null,
      description: item?.description ?? '',
      image: item?.image ?? '',
      url: item?.url ?? '',
      secondImage: item?.secondImage ?? null,
    })) ?? []

  const result: CmsBlogList = {
    items: cmsBlockItems,
    blogHomeData: {
      title: blogListQuery.blogList?.blogHomeData?.title ?? '',
      image: blogListQuery?.blogList?.blogHomeData?.image ?? '',
      meta_title: blogListQuery?.blogList?.blogHomeData?.meta_title ?? '',
      meta_keywords: blogListQuery?.blogList?.blogHomeData?.meta_keywords ?? '',
      meta_description: blogListQuery?.blogList?.blogHomeData?.meta_description ?? '',
      breadcrumbs: blogListQuery?.blogList?.blogHomeData?.breadcrumbs ?? [],
    },
    totalItems: blogListQuery?.blogList?.totalItems ?? 0,
  }

  return result
}
